import { getWorkbookDisplayMode } from '@/main/routing.utilities';
import { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';

export function isViewOnlyWorkbookMode(displayMode?: WORKBOOK_DISPLAY) {
  return displayMode === WORKBOOK_DISPLAY.VIEW || getWorkbookDisplayMode() === WORKBOOK_DISPLAY.VIEW;
}

export function isPresentationWorkbookMode(displayMode?: WORKBOOK_DISPLAY) {
  const currentWorkbookDisplay = getWorkbookDisplayMode();
  return (
    displayMode === WORKBOOK_DISPLAY.PRESENT ||
    displayMode === WORKBOOK_DISPLAY.PRESENTATION_MODE_PLUS ||
    currentWorkbookDisplay === WORKBOOK_DISPLAY.PRESENT ||
    currentWorkbookDisplay === WORKBOOK_DISPLAY.PRESENTATION_MODE_PLUS
  );
}

export function isEditWorkbookMode(displayMode?: WORKBOOK_DISPLAY) {
  return displayMode === WORKBOOK_DISPLAY.EDIT || getWorkbookDisplayMode() === WORKBOOK_DISPLAY.EDIT;
}
